import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as dictionaryActions from '../../../actions/dictionaryActions';
import * as definitionActions from '../../../actions/definitionActions';
import * as qtsActions from '../../../actions/qtsActions';
import * as studyActions from '../../../actions/studyActions';
import { GEOGRAPHY_CATG_LIST } from '../../../actions/actionTypes';
import { SIMMONS_DATA, FLEX_STUDY_TAG } from '../../../constants';
import { GEO_MAP_MODULE } from '../../geoMap/GeoMapConstant';

class CategoryDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // treedata: [],
      definationData: props.definationTree ? props.definationTree.data : [],
      geographiesData: GEOGRAPHY_CATG_LIST,
      categoryExpanded: {
        simmonsNode: {},
        qtsNode: {},
      },
      studyType: 'Dictionary',
      qtsStudyType: 'Turn-Key Omnibus',
      treedata: [],
      qtsTreedata: [],
      isHidden: true,
      isDictionaryHidden: true,
      isHiddenQts: true,
      isHiddenGeo: true,
      currentStudy: props.moduleStudy ? props.moduleStudy.st : '',
      lastStudy: '',
    };
    this.toggleDefinition = this.toggleDefinition.bind(this);
    this.toggleDictionary = this.toggleDictionary.bind(this);
    this.toggleQuickTurnSurvey = this.toggleQuickTurnSurvey.bind(this);
    this.toggleGeographies = this.toggleGeographies.bind(this);
    if (
      this.props.loginResponse &&
      this.props.activeAccountId &&
      this.props.moduleStudy
    ) {
      this.props.definitionActions.getDefinitionTreeLoad(
        this.props.loginResponse.data.token,
        this.props.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
        undefined,
        true
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.dictionaryTree !== nextProps.dictionaryTree &&
      nextProps.dictionaryTree &&
      nextProps.dictionaryTree.status === 200
    ) {
      this.setState({
        treedata: nextProps.dictionaryTree.data,
      });
    }
    /**
     * As part of the ticket PLAT-3901: make only one treelodex call for qts only,
     * avoid calling treeloadex for dictionary until the user clicks dictionary node in smartsearch
     *
     * We have cleaned up the code.
     */
    // set InstantEdge [Turn-Key Omnibus] tree data
    if (
      this.props.qtsDictionaryTree &&
      nextProps.qtsDictionaryTree &&
      this.props.qtsDictionaryTree === nextProps.qtsDictionaryTree &&
      this.state.qtsTreedata.length === 0
    ) {
      this.setState({
        qtsTreedata: [
          {
            keyword: 'IE',
            midpoint: null,
            node: 0,
            rectype: 'IE',
            shortText: 'Turn-Key Omnibus',
            uniqueId: '-1',
            children: [...nextProps.qtsDictionaryTree.data],
          },
        ],
      });
    }

    if (
      this.props.qtsDictionaryTree !== nextProps.qtsDictionaryTree &&
      nextProps.qtsDictionaryTree &&
      nextProps.qtsDictionaryTree.status === 200
    ) {
      this.setState({
        qtsTreedata: [
          {
            keyword: 'IE',
            midpoint: null,
            node: 0,
            rectype: 'IE',
            shortText: this.state.qtsStudyType,
            uniqueId: '-1',
            children: [...nextProps.qtsDictionaryTree.data],
          },
        ],
      });
    }

    if (
      this.props.loginResponse &&
      this.props.activeAccountId &&
      nextProps.moduleStudy &&
      ((this.props.lastStudySelected !== undefined
      && this.props.lastStudySelected !== nextProps.moduleStudy.st && !this.state.flag) ||
      !_.isEqual(this.props.moduleStudy, nextProps.moduleStudy))
    ) {
      this.setState(() => ({
        currentStudy: nextProps.moduleStudy.st,
        flag: true,
      }));
      this.props.dictionaryActions.getDictionaryTreeLoad(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        nextProps.moduleStudy.productNo,
        0,
        SIMMONS_DATA,
      );

      this.props.studyActions.updateCommonStudy({ lastStudySelected: nextProps.moduleStudy.st });
      // get QTS tree loaded
      const filter = 'qts';
      this.props.qtsActions.getDictionaryTreeLoad(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        nextProps.moduleStudy.pn,
        0,
        filter,
      );

      this.props.dictionaryActions.dictionaryTargetReset();
      this.props.definitionActions.getDefinitionTreeLoad(
        this.props.loginResponse.data.token,
        nextProps.moduleStudy.ss === 'SIMMONS' ? 1 : 2,
        this.props.activeAccountId,
        nextProps.moduleStudy.pn,
        undefined,
        true
      );
      this.handleDictionaryReset();
      this.setState({ treedata: [], isHidden: true, isDictionaryHidden: true });
    } else if (
      this.props.definationTree !== nextProps.definationTree &&
      nextProps.definationTree &&
      nextProps.definationTree.status === 'SUCCESS'
    ) {
      this.setState({ definationData: [...nextProps.definationTree.data] });
    }

    /*
    if (this.props.definationTree !== nextProps.definationTree) {
      this.setState({ definationData: [...nextProps.definationTree.data] });
    } */
  }

  getChildren = category => {
    // if (category.children && category.children.length && (category.rectype === 'C')) {
    if (category.children && category.children.length) {
      return this.renderCategories(category.children);
    }
    return false;
  };

  getQtsChildren = category => {
    // if (category.children && category.children.length && (category.rectype === 'C')) {
    if (category.children && category.children.length) {
      return this.renderQtsCategories(category.children);
    }
    return false;
  };

  getCategoryClasses = category =>
    `category ${
      category.rectype === 'Q' ? 'category-question' : 'category-folder'
    } ${
      this.props.selectedCategoryID === category.keyword
        ? 'category-selected'
        : ''
    }`;

  getQtsCategoryClasses = category =>
    `category ${
      category.rectype === 'Q' ? 'category-question category-question--qts' : 'category-folder category-folder--qts'
    } ${
      this.props.selectedCategoryID === category.keyword
        ? 'category-selected category-selected--qts'
        : ''
    }`;

  handleNodeClick = category => {
    this.setState({
      categoryExpanded: {
        ...this.state.categoryExpanded,
        simmonsNode: {
          ...this.state.categoryExpanded.simmonsNode,
          ...{
            [category.node]: !this.state.categoryExpanded.simmonsNode[
              category.node
            ],
          },
        },
      },
    });
    if (!this.state.categoryExpanded.simmonsNode[category.node]) {
      this.props.dictionaryActions.getDictionaryTreeLoad(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        this.props.moduleStudy.pn,
        category.node,
        SIMMONS_DATA,
      );
    }
  };

  handleQtsNodeClick = category => {
    this.setState({
      categoryExpanded: {
        ...this.state.categoryExpanded,
        qtsNode: {
          ...this.state.categoryExpanded.qtsNode,
          ...{
            [category.node]: !this.state.categoryExpanded.qtsNode[
              category.node
            ],
          },
        },
      },
    }, () => {
      const expendedNode = this.state.categoryExpanded.qtsNode;
      if (expendedNode[category.node]) {
        const filter = 'qts';
        this.props.qtsActions.getDictionaryTreeLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          this.props.moduleStudy.pn,
          category.node,
          filter,
        );
      }
    });
  };

  handleDefinitionNodeClick = def => {
    this.setState({
      categoryExpanded: {
        ...this.state.categoryExpanded,
        ...{
          [def.definitionId]: !this.state.categoryExpanded[def.definitionId],
        },
      },
    });
  };

  handleDictionaryReset() {
    this.setState({ categoryExpanded: { simmonsNode: {}, qtsNode: {} } });
  }

  toggleDefinition() {
    // const isHidden = this.state.isHidden;
    this.setState({
      isHidden: !this.state.isHidden,
    });
  }

  toggleDictionary() {
    this.setState(() => ({ isDictionaryHidden: !this.state.isDictionaryHidden }), () => {
      if (!this.state.isDictionaryHidden && this.state.treedata.length === 0) {
        this.props.dictionaryActions.getDictionaryTreeLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          this.props.moduleStudy.pn,
          0,
          SIMMONS_DATA,
        );
      }
    });
  }

  toggleQuickTurnSurvey() {
    // const isHidden = this.state.isHidden;
    this.setState({
      isHiddenQts: !this.state.isHiddenQts,
    });
  }

  toggleGeographies() {
    this.setState({
      isHiddenGeo: !this.state.isHiddenGeo,
    });
  }

  defFolderColor = scope => {
    let iconType = 'folder-green';
    switch (scope) {
      case 1:
        iconType = 'folder-light-green';
        break;
      case 2:
        iconType = 'folder-purple';
        break;
      case 3:
        iconType = 'folder-light-purple';
        break;
      case 4:
        iconType = 'folder-yellow';
        break;
      case 5:
        iconType = 'folder-light-yellow';
        break;
      default:
        iconType = 'folder-green';
    }
    return iconType;
  };

  renderDefinition = data =>
    data.map(def => (
      <li key={def.definitionId}>
        <div className="category-folder">
          <button
            onClick={() =>
              this.props.handleCategoryChange(
                def.folderName,
                def.productId,
                'D',
                def.definitionId,
              )
            }
            title={def.folderName}
          >
            <span
              className={`node-icon fa fa-folder ${this.defFolderColor(
                def.scope,
              )}`}
            />{' '}
            <span className="define-color">{def.folderName}</span>
          </button>
        </div>
      </li>
    ));

  renderGeographies = data =>
    data.map(geo => (
      <li key={geo.nodeId}>
        <div className="category-folder">
          <button
            onClick={() =>
              this.props.handleCategoryChange(
                geo.name,
                '',
                geo.type,
                geo.nodeId,
              )
            }
            title={geo.name}
          >
            <span
              className={`node-icon fa fa-globe ${this.defFolderColor(
                geo.scope,
              )}`}
            />{' '}
            <span className="define-color">{geo.name}</span>
          </button>
        </div>
      </li>
    ));

  renderCategories = data =>
    data.map(category => (
      <li key={category.node}>
        <div className="category-name">
          {category.rectype !== 'Q' ? (
            <button
              className={
                this.props.selectedCategoryID === category.keyword
                  ? 'caret-icon caret-white'
                  : 'caret-icon caret-blue'
              }
              onClick={() => this.handleNodeClick(category)}
            >
              {this.state.categoryExpanded.simmonsNode[category.node]
                ? String.fromCharCode(9660)
                : String.fromCharCode(9654)}
            </button>
          ) : (
            false
          )}
          <button
            className={this.getCategoryClasses(category)}
            onClick={() =>
              this.props.handleCategoryChange(
                category.shortText,
                category.keyword,
                category.rectype,
                category.uniqueId,
                category.pathId,
              )
            }
            title={`${category.rectype === 'Q' ? 'Q. ' : 'F. '} ${
              category.shortText
            }`}
          >
            <div className="full-selected" />
            {category.rectype === 'Q' ? 'Q. ' : ''}
            {category.shortText}
          </button>
        </div>

        {this.state.categoryExpanded.simmonsNode[category.node]
          ? <ul>{this.getChildren(category)}</ul>
          : false}

      </li>
    ));

  renderQtsCategories = data =>
    data.map(category => (
      <li key={category.node}>
        <div className="category-name category-name--qts">
          {category.rectype !== 'Q' ? (
            <button
              className={
                this.props.selectedCategoryID === category.keyword
                  ? 'caret-icon caret-white'
                  : 'caret-icon caret-blue'
              }
              onClick={() => this.handleQtsNodeClick(category)}
            >
              {this.state.categoryExpanded.qtsNode[category.node]
                ? String.fromCharCode(9660)
                : String.fromCharCode(9654)}
            </button>
          ) : (
            false
          )}
          <button
            className={this.getQtsCategoryClasses(category)}
            onClick={() =>
              this.props.handleCategoryChange(
                category.shortText,
                "IE",
                category.rectype,
                category.uniqueId,
                category.pathId,
              )
            }
            title={`${category.rectype === 'Q' ? 'Q. ' : 'F. '} ${
              category.shortText
            }`}
          >
            <div className="full-selected" />
            {category.rectype === 'Q' ? 'Q. ' : ''}
            {category.shortText}
          </button>
        </div>
        <ul>
          {this.state.categoryExpanded.qtsNode[category.node]
            ? this.getQtsChildren(category)
            : false}
        </ul>
      </li>
    ));

  render() {
    return (
      <div>
        <li key="all">
          <div className="category-name">
            <button
              className="category category-folder"
              onClick={() => {
                this.props.handleCategoryChange('ALL', '-1');
                this.handleDictionaryReset();
              }}
              title="ALL"
            >
              <div className="full-selected" />
              <b>ALL</b>
            </button>
          </div>
        </li>
        {(this.state.currentStudy && this.props.selectedModule !== GEO_MAP_MODULE) &&
          this.state.currentStudy.toLowerCase().includes(FLEX_STUDY_TAG) && (
         <li key="geographies">
            <div className="category-name">
              <button
                className="caret-icon caret-blue"
                onClick={this.toggleGeographies}
              >
                {!this.state.isHiddenGeo
                  ? String.fromCharCode(9660)
                  : String.fromCharCode(9654)}
              </button>
              <button
                className="category category-folder"
                title="Geographies"
                onClick={() => {
                  this.props.handleCategoryChange(
                    'Geographies',
                    '-1',
                    'G',
                    'Geographies_Cat',
                  );
                  this.handleDictionaryReset();
                }}
              >
                Geographies
              </button>
            </div>
          </li>
          )}
        {(!this.state.isHiddenGeo && this.props.selectedModule !== GEO_MAP_MODULE) &&
        this.state.currentStudy.toLowerCase().includes(FLEX_STUDY_TAG)
          ? this.renderGeographies(this.state.geographiesData)
          : ''}
        <li key="definitions">
          <div className="category-name">
            <button
              className="caret-icon caret-blue"
              onClick={this.toggleDefinition}
            >
              {!this.state.isHidden
                ? String.fromCharCode(9660)
                : String.fromCharCode(9654)}
            </button>
            <button
              className="category category-folder"
              title="Definitions"
              onClick={() => {
                this.props.handleCategoryChange(
                  'Definitions',
                  '-1',
                  'D',
                  '-1',
                );
                this.handleDictionaryReset();
              }}
            >
              Definitions
            </button>
          </div>
        </li>
        {!this.state.isHidden
          ? this.renderDefinition(this.state.definationData)
          : ''}

        <li key="dictionary">
          <div className="category-name">
            <button
              className="caret-icon caret-blue"
              onClick={this.toggleDictionary}
            >
              {!this.state.isDictionaryHidden
                ? String.fromCharCode(9660)
                : String.fromCharCode(9654)}
            </button>
            <button
              className="category category-folder"
              title="Definitions"
              onClick={() => {
                this.props.handleCategoryChange(
                  'Dictionary',
                  'SIMMONSTYPE',
                  'C',
                  '-1',
                );
              }}
            >
              Dictionary
            </button>
          </div>

            {!this.state.isDictionaryHidden
            ? <ul>{this.renderCategories(this.state.treedata)}</ul>
            : ''}
        </li>
        {!(
          this.state.currentStudy.toLowerCase().includes(FLEX_STUDY_TAG)
        ) &&
          this.props.qtsDictionaryTree &&
          this.props.qtsDictionaryTree.data.length > 0 &&
          this.renderQtsCategories(this.state.qtsTreedata)}
      </div>
    );
  }
}

CategoryDropdown.propTypes = {
  dictionaryTree: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  qtsDictionaryTree: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  definationTree: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  dictionaryActions: PropTypes.shape({
    getDictionaryTreeLoad: PropTypes.func,
    dictionaryTargetReset: PropTypes.func,
  }),
  qtsActions: PropTypes.shape({
    getDictionaryTreeLoad: PropTypes.func,
    dictionaryTargetReset: PropTypes.func,
  }),
  definitionActions: PropTypes.shape({
    getDefinitionTreeLoad: PropTypes.func,
  }),
  studyActions: PropTypes.shape({
    updateCommonStudy: PropTypes.func,
  }),
  handleCategoryChange: PropTypes.func,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
    status: PropTypes.number,
  }),
  activeAccountId: PropTypes.number,
  selectedCategoryID: PropTypes.string,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    st: PropTypes.string,
    ss: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    dictionaryTree: state.dictionary.dictionaryTree,
    qtsDictionaryTree: state.qts.qtsDictionaryTree,
    definationTree: state.definition.definitionTree,
    lastStudySelected: state.study.lastStudySelected,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    qtsActions: bindActionCreators(qtsActions, dispatch),
    definitionActions: bindActionCreators(definitionActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(CategoryDropdown);
